import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import { statusPalette } from 'components/core/colors';
import Tooltip from 'components/core/Tooltip';
// Custom
import AppIcon from 'components/icons/AppIcon';

const WarningIcon = ({
  iconId, iconSize, tooltipId, tooltipValues,
}) => (tooltipId ? (
  <Tooltip content={<LocalizedMessage id={tooltipId} values={tooltipValues} />}>
    <AppIcon id={iconId || 'warningAlt'} fontSize={iconSize} color={statusPalette.warning} />
  </Tooltip>
) : <AppIcon id={iconId || 'warningAlt'} fontSize={iconSize} color={statusPalette.warning} />);

WarningIcon.propTypes = {
  iconId: PropTypes.string,
  iconSize: PropTypes.oneOf(['default', 'large', 'medium', 'small']),
  tooltipId: PropTypes.string,
  tooltipValues: PropTypes.object,
};

WarningIcon.defaultProps = {
  iconId: null,
  iconSize: 'default',
  tooltipValues: null,
  tooltipId: null,
};

module.exports = WarningIcon;



// WEBPACK FOOTER //
// ./components/misc/WarningIcon.js